import script from "./BottomPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomPopup.vue?vue&type=script&setup=true&lang=js"

import "./BottomPopup.vue?vue&type=style&index=0&id=867e364e&lang=css"

const __exports__ = script;

export default __exports__